// extracted by mini-css-extract-plugin
export var aiStarSpin = "_rg-1";
export var spinner = "_rg-0";